import { render, staticRenderFns } from "./FriendSurveyAnswer.vue?vue&type=template&id=3f944454&"
import script from "./FriendSurveyAnswer.vue?vue&type=script&lang=js&"
export * from "./FriendSurveyAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports